<template lang="pug">
  server-data(
    no-init
    :method="method"
    v-slot="{ init, serverData, loading }"
  )
    ev-dialog(
      v-bind="attrs"
      v-on="$listeners"
    )
      template(v-slot:content)
        p(
          v-bind="messageAttrs"
          v-html="message"
        )

      template(v-slot:actions="{ close }")
        v-btn(
          v-bind="extendCloseBtnAttrs"
          @click="() => cancel({ close })"
        ) {{ extendCloseBtnAttrs['btn-text'] || DEFAULT_BTNS_TEXT[BTNS_TYPES.close] }}
        v-btn(
          :loading="loading"
          v-bind="extendConfirmBtnAttrs"
          @click="() => confirm({ init, close })"
        ) {{ extendConfirmBtnAttrs['btn-text'] || DEFAULT_BTNS_TEXT[BTNS_TYPES.confirm] }}
</template>

<script>
import EvDialog from '../EvDialog.vue';

const BTNS_TYPES = {
  close: 1,
  confirm: 2,
};

const DEFAULT_BTNS_TEXT = {
  [BTNS_TYPES.close]: 'Отмена',
  [BTNS_TYPES.confirm]: 'Ок',
};

export default {
  components: {
    EvDialog,
  },
  props: {
    method: { type: Function, default: () => null },
    closeBtnAttrs: { type: Object, default: () => ({}) },
    confirmBtnAttrs: { type: Object, default: () => ({}) },
    successCallback: { type: Function, default: () => null },
    title: { type: String, default: 'Подтвердите действие' },
    message: { type: String, default: 'Вы уверены, что хотите выполнить это действие?' },
    isRequest: { type: Boolean, default: false },
    messageAttrs: { type: Object, default: () => {} },
  },
  data() {
    return {
      BTNS_TYPES,
      DEFAULT_BTNS_TEXT,
    };
  },
  computed: {
    attrs() {
      return {
        ...this.$attrs,
        title: this.title,
      };
    },
    defaultBtnAttrs() {
      const { dark } = this.$vuetify.theme;

      return {
        [BTNS_TYPES.close]: {
          height: 48,
          class: 'flex-1 rounded-12',
          outlined: true,
          color: 'redesignPrimary',
        },
        [BTNS_TYPES.confirm]: {
          height: 48,
          class: 'flex-1 rounded-12',
          color: 'redesignPrimary',
          dark: !dark,
        },
      };
    },
    extendCloseBtnAttrs() {
      const { defaultBtnAttrs, closeBtnAttrs } = this;
      return {
        ...defaultBtnAttrs[BTNS_TYPES.close],
        ...closeBtnAttrs,
      };
    },
    extendConfirmBtnAttrs() {
      const { defaultBtnAttrs, confirmBtnAttrs } = this;
      return {
        ...defaultBtnAttrs[BTNS_TYPES.confirm],
        ...confirmBtnAttrs,
      };
    },
  },
  methods: {
    // TODO: можно переделать, success убрать в server-data
    async confirm({ init, close }) {
      const { successCallback } = this;

      if (this.isRequest) {
        await init().then(() => {
          successCallback();
          close();
        });
      } else {
        this.method();
        close();
      }
    },
    cancel({ close }) {
      this.$emit('cancel');
      close();
    },
  },
};
</script>
